import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import { Grid, InputLabel, FormControl, FormHelperText, Select, MenuItem } from '@mui/material';
import { toast } from 'react-toastify';
import { LoadingButton } from '@mui/lab';
import { addNewOvertimeShift } from '../../API';

const DAY_OPTIONS = [
  { value: 0, label: 'Minggu' },
  { value: 1, label: 'Senin' },
  { value: 2, label: 'Selasa' },
  { value: 3, label: 'Rabu' },
  { value: 4, label: 'Kamis' },
  { value: 5, label: 'Jumat' },
  { value: 6, label: 'Sabtu' },
];

const ModalAddOvertimeShift = ({ onClick, onDataAdd }) => {
  const [day, setDay] = useState('');
  const [startAt, setStartAt] = useState('');
  const [finishAt, setFinishAt] = useState('');
  const [payableDuration, setPayableDuration] = useState('');
  const [dayError, setDayError] = useState('');
  const [startAtError, setStartAtError] = useState('');
  const [finishAtError, setFinishAtError] = useState('');
  const [payableDurationError, setPayableDurationError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleAdd = async () => {
    setDayError('');
    setStartAtError('');
    setFinishAtError('');
    setPayableDurationError('');
    setIsLoading(true);

    if (day === '') {
      setDayError('Hari harus dipilih');
      setIsLoading(false);
      return;
    }
    if (!startAt) {
      setStartAtError('Jam mulai harus diisi');
      setIsLoading(false);
      return;
    }
    if (!finishAt) {
      setFinishAtError('Jam selesai harus diisi');
      setIsLoading(false);
      return;
    }
    if (finishAt <= startAt) {
      setFinishAtError('Jam selesai harus setelah jam mulai');
      setIsLoading(false);
      return;
    }
    const duration = parseInt(payableDuration, 10);
    if (!duration || duration < 1) {
      setPayableDurationError('Durasi dibayar minimal 1 menit');
      setIsLoading(false);
      return;
    }

    const body = {
      day,
      start_at: startAt,
      finish_at: finishAt,
      payable_duration: duration,
    };

    try {
      const res = await addNewOvertimeShift(body);
      if (res.meta.code === 201) {
        toast.success('Shift lembur berhasil ditambahkan.');
        onDataAdd();
        onClick();
      }
    } catch (error) {
      const errors = error.response?.data?.meta?.errors;
      if (errors) {
        if (errors.day) setDayError(errors.day[0]);
        if (errors.start_at) setStartAtError(errors.start_at[0]);
        if (errors.finish_at) setFinishAtError(errors.finish_at[0]);
        if (errors.payable_duration) setPayableDurationError(errors.payable_duration[0]);
        Object.values(errors)
          .flat()
          .forEach((msg) => toast.error(msg));
      } else {
        toast.error('Gagal menambahkan shift lembur');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Grid container spacing={4}>
      <Grid item xs={12} lg={6}>
        <FormControl fullWidth error={!!dayError}>
          <InputLabel required id="day-select-label">
            Hari
          </InputLabel>
          <Select
            labelId="day-select-label"
            id="day-select"
            value={day}
            label="Hari"
            onChange={(e) => setDay(e.target.value)}
          >
            {DAY_OPTIONS.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
          {dayError && <FormHelperText>{dayError}</FormHelperText>}
        </FormControl>
      </Grid>
      <Grid item xs={12} lg={6}>
        <TextField
          value={payableDuration}
          onChange={(e) => setPayableDuration(e.target.value)}
          required
          type="number"
          label="Durasi Dibayar (menit)"
          fullWidth
          inputProps={{ min: 1 }}
          error={!!payableDurationError}
          helperText={payableDurationError}
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <TextField
          value={startAt}
          onChange={(e) => setStartAt(e.target.value)}
          required
          type="time"
          label="Jam Mulai"
          fullWidth
          InputLabelProps={{ shrink: true }}
          inputProps={{ step: 60 }}
          error={!!startAtError}
          helperText={startAtError}
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <TextField
          value={finishAt}
          onChange={(e) => setFinishAt(e.target.value)}
          required
          type="time"
          label="Jam Selesai"
          fullWidth
          InputLabelProps={{ shrink: true }}
          inputProps={{ step: 60 }}
          error={!!finishAtError}
          helperText={finishAtError}
        />
      </Grid>

      <Grid item xs={12} lg={12}>
        <LoadingButton
          loading={isLoading}
          role="CircularProgress"
          color="color"
          variant="contained"
          fullWidth
          size="large"
          onClick={handleAdd}
        >
          TAMBAH
        </LoadingButton>
      </Grid>
    </Grid>
  );
};

export default ModalAddOvertimeShift;
